import React from "react";
import HeroAlternative from "../../components/HeroAlternative/Hero";
import AlternatingImageText from "../../components/AlternatingImageText/AlternatingImageText";
import Contact from "../../components/Contact/Contact";
import styled from "styled-components";

export default function OurTeam() {
  const teamMembers = [
    {
      name: "Renée Horton-Coker",
      description: `Renée is the founder and director of August Twenty Limited. She has over 25 years experience of project, engagement, and client management as a leader and team player. Renée has held several senior positions in Europe, Asia, North America, and Africa including Global Program Director, Head of Project Management Office, and Commercial Director.`,
      linkedinUrl: "https://www.linkedin.com/in/reneehortoncoker/"
    },
    {
      name: "Adolphus Zekpeh",
      description: `Adolphus is an experienced administrator with a background in educational administration and human resource management. He holds a Bachelor of Science degree in Educational Administration and a professional certificate in Human Resource Management.`,
      linkedinUrl: "https://www.linkedin.com/in/adolphus-zekpeh-14b5a01aa/"
    },
    {
      name: "Serena Horton-Spring",
      description: `Serena is our property and project manager with experience across business operations, real estate management, and administrative coordination. She specialises in overseeing property assets, managing tenant and client relationships, and delivering organised, efficient systems that support day-to-day operations and long-term sustainable development goals.`,
      linkedinUrl: "https://www.linkedin.com/in/serena-horton-spring-195869187/"
    },
    {
      name: "Zeekar Karwah",
      description: `Zeekar is a Public Administration graduate with experience in administration, policy support, and community development. Skilled in Microsoft Office tools and passionate about effective leadership, institutional growth, and human rights advocacy.`,
      linkedinUrl: "https://www.linkedin.com/in/zeekar-karwah-543315345/"
    },
  ];

  return (
    <>
      <HeroAlternative 
        title="Meet our team of specialists and project managers"
        imageSrc="/clapping.jpg"
      />
      
      {/* Team Members Section */}
      <TeamSection>
        {/* <TeamHeader>
          <TeamTitle>Our Leadership Team</TeamTitle>
          <TeamSubtitle>
            Meet the dedicated professionals who drive our success and innovation
          </TeamSubtitle>
        </TeamHeader> */}
      
        <TeamGrid>
          {teamMembers.map((member, index) => (
            <TeamCard key={index}>
              <MemberIcon>
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="#101015">
                  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                </svg>
              </MemberIcon>
              
              <MemberInfo>
                <TeamMemberName>{member.name}</TeamMemberName>
                <TeamMemberDescription>
                  {member.description}
                </TeamMemberDescription>
                
                {member.linkedinUrl && (
                  <LinkedInLink href={member.linkedinUrl} target="_blank" rel="noopener noreferrer">
                    <LinkedInIcon>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="#0077B5">
                        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                      </svg>
                    </LinkedInIcon>
                    <span>Connect on LinkedIn</span>
                  </LinkedInLink>
                )}
              </MemberInfo>
            </TeamCard>
          ))}
        </TeamGrid>
      </TeamSection>
    </>
  );
}

// Styled Components
const TeamSection = styled.section`
  background: #FFF;
  color: #000;
  padding: 60px 80px;
  
  @media (max-width: 768px) {
    padding: 60px 24px;
  }
`;

const TeamHeader = styled.div`
  text-align: center;
  margin-bottom: 60px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

const TeamTitle = styled.h1`
  font-size: 48px;
  color: #000;
  font-family: 'Playfair Display', serif;
  font-weight: 600;
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    font-size: 36px;
  }
`;

const TeamSubtitle = styled.p`
  font-size: 20px;
  color: #666;
  line-height: 1.6;
  
  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

const TeamGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
  margin-bottom: 80px;
  
  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }
`;

const TeamCard = styled.div`
  border-radius: 20px;
  padding: 40px;
  transition: all 0.3s ease;
  border: 1px solid #F0F0F0;
`;

const MemberIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  background: #F5F5F5;
  border-radius: 50%;
  margin-bottom: 30px;
  
  svg {
    opacity: 0.7;
  }
`;

const MemberInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const TeamMemberName = styled.h2`
  font-size: 28px;
  color: #000;
  font-family: 'Playfair Display', serif;
  font-weight: 500;
  line-height: 1.2;
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

const TeamMemberDescription = styled.p`
  font-size: 16px;
  line-height: 1.8;
  color: #444;
  margin-bottom: 25px;
  
  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 1.6;
  }
`;

const LinkedInLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #0077b5;
  text-decoration: none;
  font-weight: 600;
  font-size: 16px;
  transition: all 0.3s ease;
  padding: 10px 0;
  
  &:hover {
    color: #005582;
    transform: translateX(5px);
  }
`;

const LinkedInIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ComingSoonSection = styled.div`
  text-align: center;
  padding: 60px 40px;
  background: #F8F8F8;
  border-radius: 20px;
  border: 2px dashed #E0E0E0;
  max-width: 800px;
  margin: 0 auto;
`;

const ComingSoonTitle = styled.h3`
  font-size: 28px;
  color: #000;
  font-family: 'Playfair Display', serif;
  font-weight: 500;
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

const ComingSoonText = styled.p`
  font-size: 18px;
  line-height: 1.6;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;